import React from 'react';
import { MenuItem, Select, Tooltip } from '@mui/material';

/*
 * Model selector for the current thread.
 *
 * The list comes from the backend (/config), not from a constant here — the
 * server validates every request against the same allowlist, so a model that
 * isn't offered cannot be reached by editing the request body. Keeping the
 * options server-driven means the two can't drift apart.
 */
const ModelPicker = ({ models, value, onChange, disabled }) => {
  if (!models || models.length < 2) return null;

  return (
    <Select
      value={value || models[0].id}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
      size="small"
      variant="standard"
      disableUnderline
      sx={{
        fontSize: 12.5,
        color: 'text.secondary',
        '& .MuiSelect-select': { py: 0.25, pr: '20px !important' },
      }}
    >
      {models.map((model) => (
        <MenuItem key={model.id} value={model.id} sx={{ fontSize: 13 }}>
          <Tooltip title={model.hint || ''} placement="right">
            <span>{model.label}</span>
          </Tooltip>
        </MenuItem>
      ))}
    </Select>
  );
};

export default ModelPicker;
